module.exports = __webpack_public_path__ + "img/shenhese.94549cbe.png";